(() => {
  if (window.__orvonVisualizerLoader) return;
  window.__orvonVisualizerLoader = true;
  const pendingScripts = new Map();

  function loadApplication(source) {
    if (customElements.get("orvon-room-visualizer")) return Promise.resolve();
    if (!source) return Promise.reject(new Error("missing_application_source"));
    if (!pendingScripts.has(source)) {
      pendingScripts.set(source, new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = source;
        script.async = true;
        script.onload = resolve;
        script.onerror = () => reject(new Error("application_load_failed"));
        document.head.append(script);
      }));
    }
    return pendingScripts.get(source);
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest?.("orvon-room-visualizer [data-ov-open]");
    if (!button || customElements.get("orvon-room-visualizer")) return;
    event.preventDefault();
    const visualizer = button.closest("orvon-room-visualizer");
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    try {
      await loadApplication(visualizer.dataset.appSrc);
      visualizer.open?.();
    } catch {
      window.alert(visualizer.dataset.loadError);
    } finally {
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }, true);
})();
